<template>
  <div v-if="internalIsOpen" class="modal fade show custom-modal-backdrop" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-items-center">
              <h1 class="mb-0">{{ details.name }}</h1>
              <div class="d-flex align-items-center gap-2">
                <span v-if="details.unit_name" class="badge bg-info fs-6">
                  {{ details.unit_name }}
                </span>
                <button
                    @click="closeModal"
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-0">
        <div class="modal-body pt-0">
          <div v-if="loading" class="text-center p-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-else>
            <table class="table table-bordered mb-0">
              <tbody>
                <tr>
                  <th class="bg-light w-50">Total Target</th>
                  <td class="text-end fw-bold text-dark">{{ details.total_target }}</td>
                </tr>
                <tr>
                  <th class="bg-light">Already Achieved</th>
                  <td class="text-end fw-bold text-dark">{{ details.already_achieved }}</td>
                </tr>
                <tr>
                  <th class="bg-light">Balance</th>
                  <td class="text-end fw-bold text-dark">{{ details.balance }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer pt-0 border-top-0">
          <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch, inject, defineExpose } from 'vue';
import handleCompanyContact from '@/services/modules/companyContact';

const { fetchActivityDetails } = handleCompanyContact();

const props = defineProps({
  isOpen: Boolean,
  item: Object,
  companyId: [Number, String]
});

const emit = defineEmits(['close']);
const showError = inject('showError');

const internalIsOpen = ref(false);
const details = ref({});
const loading = ref(false);

const closeModal = () => {
  internalIsOpen.value = false;
  emit('close');
};

const loadDetails = async (item, companyId) => {
  if (!item || !companyId) return;

  loading.value = true;
  details.value = { name: item.name };
  
  const query = `?company_id=${companyId}&project_account_id=${item.id}&is_personalized=1`;
  try {
    const res = await fetchActivityDetails(query);
    if(!res.status) {
      showError(res.message);
      closeModal();
      return;
    }
    details.value = res.data;
  } catch (error) {
    console.error("Error fetching activity details:", error);
    showError("Something went wrong!");
    closeModal();
  } finally {
    loading.value = false;
  }
};

const openModal = (item, companyId) => {
  internalIsOpen.value = true;
  loadDetails(item, companyId);
};

defineExpose({ openModal, closeModal });

watch(() => props.isOpen, (newVal) => {
  internalIsOpen.value = newVal;
  if (newVal && props.item) {
    loadDetails(props.item, props.companyId);
  }
});
</script>

<style scoped>
.custom-modal-backdrop {
  display: block;
  background-color: rgba(28, 29, 28, 0.2);
}

.w-50 {
  width: 50% !important;
}

.modal {
  z-index: 1060;
}
</style>
